$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-origin-se-kit');
})
$('.pnr_cart').click(function(){
    var element = document.querySelector(".originse_section10");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".originse_section11");
    element.scrollIntoView({block: "end"});
})

//section3
var box3=document.getElementsByClassName('box3');
var s6Controller = new ScrollMagic.Controller();


new ScrollMagic.Scene({
    triggerElement: '.originse_section3',
    duration: "90%",
    triggerHook: 0,
    offset: "0"
  })
  .setPin('.originse_section3') // pins the element for the the scene's duration
  .addTo(s6Controller) // assign the scene to the controller
  .on("progress", function (e) {
     const scrollIndex = Math.floor(e.progress.toFixed(3) * 10);
     
     var i=0;
     for(i;i<10;i++){
      box3[0].classList.remove("step"+i);
     }
     box3[0].classList.add("step"+scrollIndex);
  });


// section7
var function1_buttonlist=document.getElementsByClassName('function1_button');
var function1_imglist=document.getElementsByClassName('function1_img');
var i=0;
console.log(function1_buttonlist.length);
for ( i = 0; i<function1_buttonlist.length; i++) {
  function1_buttonlist[i].onclick=function(){
   if(this.classList.contains('picked')){

   }else{
     var j=0;
     for ( j; j<function1_buttonlist.length; j++){//将含有picked类的标签去掉picked类
     if(function1_buttonlist[j].classList.contains('picked')){
        function1_buttonlist[j].classList.remove('picked');
      
     }
     }
     this.classList.add('picked');
     
     for ( j=0; j<function1_buttonlist.length; j++){
     if(function1_imglist[j].classList.contains('disappear')){

     }else{
       function1_imglist[j].classList.add('disappear')
     }
     
   }
   // console.log(this.getAttribute(['datenumber']));
   function1_imglist[this.getAttribute(['datenumber'])].classList.remove('disappear');
  }

}
}
//---------------------------------------------------------
// section7的js 
var function3_buttonlist=document.getElementsByClassName('function3_button');
var function3_imglist=document.getElementsByClassName('function3_img');
var function3_imgtitle_list=document.getElementsByClassName('function3_img_title');

var m=0;
console.log(function3_buttonlist.length);
for ( m; m<function3_buttonlist.length; m++) {
  function3_buttonlist[m].onclick=function(){
   if(this.classList.contains('picked')){

   }else{
     var n=0;
     for ( n; n<function3_buttonlist.length; n++){//将含有picked类的标签去掉picked类
     if(function3_buttonlist[n].classList.contains('picked')){
        function3_buttonlist[n].classList.remove('picked');
      
     }
     }
     this.classList.add('picked');
     
     for ( n=0; n<function3_buttonlist.length; n++){
     if(function3_imglist[n].classList.contains('disappear')){

     }else{
       function3_imglist[n].classList.add('disappear');
       function3_imgtitle_list[n].classList.add('disappear');
     }
     
   }
   // console.log(this.getAttribute(['datenumber']));
   function3_imglist[this.getAttribute(['datenumber'])].classList.remove('disappear');
   function3_imgtitle_list[this.getAttribute(['datenumber'])].classList.remove('disappear');
  }

}
}

//section11
const allIcons = document.querySelectorAll('.originse_section11 .glide__bullet');


    // event listeners
    allIcons.forEach(el =>{
        el.addEventListener('mouseenter', ()=>{
            el.closest(".glide__bullet").click();
        });
    })
    new Glide('.glide',{
        gap: 0
    }).mount();